//
//
//
//
//
//

import gameCont from '../game/index.vue'
export default {
  name: "lottery",
  components: {gameCont},
  data() {
    return {
      gameTypeCode: '4',
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/build922/views/home/pages-4.vue